// filterView/parts/combineToggle.js — "alle / mindestens eine" (combine and / or) as two pressed-state buttons
// (plan documents_admin-search, phase filter-varianten). Changes go through the store; update(combine) shows the state.
//
// createCombineToggle({ store, texts }) → { element, update, destroy }
// createCombineSentence({ store, texts }) → { element, update, destroy } — the toggle inside the sentence
//   "Zeige Dokumente, die [alle | mindestens eine] der folgenden Bedingungen erfüllen:" (builder B, form C)

import { createDisposers } from '../../core/disposers.js';
import { setCombine } from '../conditionSet.js';

export function createCombineToggle({ store, texts }) {
    const disposers = createDisposers();
    const element = document.createElement('span');
    element.className = 'topo2-filterview-seg';
    element.setAttribute('role', 'group');
    element.setAttribute('aria-label', texts.FILTER_VIEW_COMBINE);

    const buttons = {};
    for (const [combine, key] of [['and', 'FILTER_VIEW_ALL'], ['or', 'FILTER_VIEW_ANY']]) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'topo2-btn topo2-filterview-seg-btn';   // topo2-btn: basic.css's button hover leaves it alone
        button.textContent = texts[key];
        const onClick = () => store.set((set) => setCombine(set, combine));
        button.addEventListener('click', onClick);
        disposers.add(() => button.removeEventListener('click', onClick));
        buttons[combine] = button;
        element.append(button);
    }

    return {
        element,
        update(combine) {
            for (const [key, button] of Object.entries(buttons)) {
                button.setAttribute('aria-pressed', String(key === combine));
            }
        },
        destroy() {
            disposers.dispose();
        },
    };
}

export function createCombineSentence({ store, texts }) {
    const toggle = createCombineToggle({ store, texts });
    const element = document.createElement('p');
    element.className = 'topo2-filterview-lead';
    element.append(`${texts.FILTER_VIEW_LEAD} `, toggle.element, ` ${texts.FILTER_VIEW_LEAD_END}`);
    return { element, update: toggle.update, destroy: toggle.destroy };
}
